(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-primo-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NAV = '[data-sticky-nav]';
    var BTN = '[data-sticky-nav-button]';
    var ACTIVE = 'sticky-nav__button--active';
    var ticking = false;

    function findTarget(id) {
      if (!id) return null;
      return (
        document.getElementById(id) ||
        document.getElementById('shopify-section-' + id)
      );
    }

    function getOffset(nav) {
      var extra = parseInt(nav.getAttribute('data-offset'), 10) || 0;
      var wrapper = nav.closest('.shopify-section') || nav;
      var stickyTop = parseInt(window.getComputedStyle(wrapper).top, 10) || 0;
      return stickyTop + wrapper.offsetHeight + extra;
    }

    function update() {
      ticking = false;
      document.querySelectorAll(NAV).forEach(function (nav) {
        var buttons = Array.prototype.slice.call(nav.querySelectorAll(BTN));
        var offset = getOffset(nav);
        var current = null;

        // The active button is the last one whose target has reached the
        // line under the bar. It stays active until the next target arrives.
        buttons.forEach(function (btn) {
          var target = findTarget(btn.getAttribute('data-target'));
          if (target && target.getBoundingClientRect().top <= offset + 1) {
            current = btn;
          }
        });

        buttons.forEach(function (btn) {
          var isActive = btn === current;
          btn.classList.toggle(ACTIVE, isActive);
          if (isActive) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        });

        // Keep the active button visible when the bar scrolls on mobile
        if (current) {
          var list = current.closest('.sticky-nav__list');
          if (list && list.scrollWidth > list.clientWidth) {
            var left = current.offsetLeft - list.offsetLeft;
            list.scrollTo({
              left: left - (list.clientWidth - current.offsetWidth) / 2,
              behavior: 'smooth'
            });
          }
        }
      });
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function scrollToY(y) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest(BTN);
      if (btn) {
        var nav = btn.closest(NAV);
        var target = findTarget(btn.getAttribute('data-target'));
        if (!target) return;
        event.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - getOffset(nav);
        scrollToY(y);
        return;
      }

      if (event.target.closest('[data-sticky-nav-top]')) {
        scrollToY(0);
      }
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:section:reorder', requestUpdate);
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();
})();
